module.exports = __webpack_public_path__ + "static/media/signup_graphic_1_web.d53d2db2.svg";